import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { Regulation } from '../../shared/models/regulation.model';
import { RegulationsApiService } from '../../shared/services/auth/regulations-api.service';

@Injectable({
  providedIn: 'root',
})
export class RegulationsResolver implements Resolve<Regulation[]> {
  constructor(private regulationsApiService: RegulationsApiService) {
  }

  public resolve(): Observable<Regulation[]> {
    return this.regulationsApiService.getRegulations();
  }
}
